import { DropdownFilter } from "components/Filters/DropdownFilter/DropdownFilter";
import { MultiToggleFilter } from "components/Filters/MultiToggleFilter/MultiToggleFilter";
import { Panel } from "components/Panel/Panel";
import { Filter, MultiFilter, resetFilter } from "model/Filter/Filter";
import { useEffect } from "react";
import { FilterRow, FiltersContainer, InaccurateStats } from "./styles";

interface Props {
  tournamentFilter: MultiFilter<string>;
  matchFormatFilter?: Filter<string>;
}

export const TrackFilters = ({
  tournamentFilter,
  matchFormatFilter,
}: Props) => {
  useEffect(() => {
    if (
      !!matchFormatFilter &&
      !matchFormatFilter.options.includes(matchFormatFilter.selectedValue)
    ) {
      resetFilter(matchFormatFilter);
    }
  }, [matchFormatFilter?.options]);

  // todo - extract header text
  return (
    <Panel padding="padded">
      <FiltersContainer>
        <FilterRow>
          <MultiToggleFilter filter={tournamentFilter} header="Tournaments" />
        </FilterRow>
        <FilterRow>
          {!!matchFormatFilter && matchFormatFilter.options.length > 1 && (
            <DropdownFilter filter={matchFormatFilter} header="Match Format" />
          )}
        </FilterRow>
      </FiltersContainer>
      <InaccurateStats>
        Stats may be slightly inaccurate due to incomplete match data
      </InaccurateStats>
    </Panel>
  );
};
